import ApiService from "@/core/services/api.service";
import state from "./state";
import AppReportDownloadService from "@/modules/core/services/file/file_download.service";

export default {
  /**
   * Fetch Employee Yearly Attendance
   *
   * @param context
   */
  async fetchTeacherYearlyAttendanceList(context) {
    try {
      ApiService.setHeader();
      context.commit("setTeacherYearlyAttendanceBusy", true);
      const response = await ApiService.query(
        "school/attendance/teacher/yearly",
        {
          params: {
            "page[size]": state.size,
            "page[number]": state.pagination.current_page ?? 1,
            "filter[base]": state.filter?.first_name,
            date: state.filter.date,
          },
        }
      );
      console.log("Received ", response);
      context.commit("setTeacherYearlyAttendanceList", response.data.data);
      context.commit(
        "setTeacherYearlyAttendancePagination",
        response.data.meta.pagination
      );

      return response;
    } catch (error) {
      console.error(error);

      throw Error("Failed.");
    } finally {
      context.commit("setTeacherYearlyAttendanceBusy", false);
    }
  },

  /**
   * Change list filter date
   *
   * @param context
   * @param payload
   */
  changeTeacherYearlyAttendanceListDate(context, payload) {
    const date = payload.date;
    if (date !== null) {
      context.commit("setTeacherYearlyAttendanceDate", date);
    }
  },

  /**
   *
   * @param context
   * @param payload
   */
  changeTeacherYearlyAttendanceNameFilter(context, payload) {
    const filters = state.filter;

    filters.first_name = payload.name;

    context.commit("setTeacherYearlyAttendanceFilters", filters);
  },

  /**
   *
   * @param context
   * @param payload
   * @returns {Promise<*>}
   */
  async downloadTeacherYearlyAttendanceReport(context, payload) {
    console.log(payload);

    try {
      ApiService.setHeader();

      const response = await ApiService.query(
        "school/attendance/teacher/yearly/report",
        {
          responseType: "blob",
          params: {
            type: payload.type ?? 1,
            date: state.filter?.date ?? 1,
          },
        }
      );

      AppReportDownloadService.processDownload(
        response.data,
        `Teacher Yearly Report - ${payload.date}`
      );

      return response;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};
